// @ts-nocheck
import * as Types from '../../../../__generated/treasury/types';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentV2BattlePassProductQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.BattlePassInput>;
}>;

export type PaymentV2BattlePassProductQuery = {
  __typename: 'Query';
  battlePass: {
    __typename: 'BattlePassQuery';
    id: string;
    battlePass: {
      __typename: 'BattlePassPayload';
      error?: Types.BattlePassGetError | null;
      errorMsg?: string | null;
      data?: {
        __typename: 'BattlePass';
        id: string;
        name: string;
        booster: { __typename: 'BattlePassBooster'; active: boolean };
        enrollment?: {
          __typename: 'BattlePassEnrollment';
          id: string;
          rewardsAccess: Types.BattlePassRewardsAccess;
        } | null;
      } | null;
    };
  };
};

export const PaymentV2BattlePassProductQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentV2BattlePassProductQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BattlePassInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'battlePass' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'battlePass' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'input' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMsg' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'booster' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'active' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'enrollment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rewardsAccess' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePaymentV2BattlePassProductQuery__
 *
 * To run a query within a React component, call `usePaymentV2BattlePassProductQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentV2BattlePassProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentV2BattlePassProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentV2BattlePassProductQuery(
  baseOptions?: Apollo.QueryHookOptions<PaymentV2BattlePassProductQuery, PaymentV2BattlePassProductQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaymentV2BattlePassProductQuery, PaymentV2BattlePassProductQueryVariables>(
    PaymentV2BattlePassProductQueryDocument,
    options
  );
}
export function usePaymentV2BattlePassProductQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PaymentV2BattlePassProductQuery, PaymentV2BattlePassProductQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaymentV2BattlePassProductQuery, PaymentV2BattlePassProductQueryVariables>(
    PaymentV2BattlePassProductQueryDocument,
    options
  );
}
export type PaymentV2BattlePassProductQueryHookResult = ReturnType<typeof usePaymentV2BattlePassProductQuery>;
export type PaymentV2BattlePassProductQueryLazyQueryHookResult = ReturnType<
  typeof usePaymentV2BattlePassProductQueryLazyQuery
>;
export type PaymentV2BattlePassProductQueryQueryResult = Apollo.QueryResult<
  PaymentV2BattlePassProductQuery,
  PaymentV2BattlePassProductQueryVariables
>;
